
import {E_Commentsection_Selection_engine, E_Commentsection_Initiale_engine} from "./main_02_A_A.js";

export function E_commentsection_keyin(words, id) {
  var bool = JSON.parse(localStorage.getItem("container"));
  var i = sessionStorage.getItem("i_name");
  var c = i;

  if (c == null) {
    c = "Anonymous";
  }
  var box = "text=" + words+"&id="+bool[0]+"&post_id="+id+"&title="+c;
  //console.log(box);
 var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      console.log(this.responseText);
      console.log("E_Commentsection_keyin");
      //imagine using the same container..it does really help
      // container = this.responseText;
  //this is the bug
  //localStorage.setItem("container",  this.responseText);
    }
  };

  xhttp.open("POST", "./php/c_comment01.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.withCredentials = true;
  xhttp.send(box);
}



export function E_Commentsection_initial_ID(id){
//contoh
var id_changes = id.concat("_C");
  var box = "id="+id;
//  console.log(box);
 var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
  console.log(this.responseText);
 var array = JSON.parse(this.responseText);
 document.getElementById(id_changes).innerHTML = "";
 E_Commentsection_Initiale_engine(id,array);
 localStorage.setItem("T_Comment", array[1]);
 console.log(array);
    }
  };

  xhttp.open("POST", "./php/c_comment02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.withCredentials = true;
  xhttp.send(box);

}


export function E_Commentsection_output_ID(id){
//contoh
var id_changes = id.concat("_C");
  var box = "id="+id;
//  console.log(box);
 var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
  console.log(this.responseText);
 var array = JSON.parse(this.responseText);
    document.getElementById(id_changes).innerHTML = "";
 E_Commentsection_Selection_engine(id,array);
console.log(array);
    }
  };

  xhttp.open("POST", "./php/c_comment03.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.withCredentials = true;
  xhttp.send(box);
}



